export const MWEB_MINWIDTH = 750;
